interface ApiResult<T> {
  data: Ref<T | null>;
  status: Ref<'idle' | 'pending' | 'success' | 'error'>;
  trigger: () => void;
}

interface Options {
  server: boolean;
  fetchImmediately: boolean;
}

const defaultOptions: Options = {
  server: false,
  fetchImmediately: true,
};

export const useApiDirectly = <T>(
  fetchFunction: () => Promise<T>,
  handleErrorCallback?: (error: unknown) => void,
  opts: Options = defaultOptions,
): ApiResult<T> => {
  const data: Ref<T | null> = ref(null);
  const status: Ref<'idle' | 'pending' | 'success' | 'error'> = ref('idle');

  const fetchData = async () => {
    if (opts.server === false && !import.meta.client) {
      return;
    }

    status.value = 'pending';

    try {
      data.value = await fetchFunction();
      status.value = 'success';
    } catch (error) {
      status.value = 'error';

      if (handleErrorCallback !== undefined) {
        handleErrorCallback(error);
      }
    }
  };

  if (opts.fetchImmediately) {
    fetchData();
  }

  const trigger = () => {
    fetchData();
  };

  return { data, status, trigger };
};
